import {defineQuery} from 'next-sanity';

import {DOCUMENT_TYPE_ARTICLE} from '@/modules/article/sanity/constants';
import {DOCUMENT_TYPE_ARTICLE_FRONTPAGE} from '@/modules/article/sanity/frontpage/constants';
import {DOCUMENT_TYPE_ABOUT_FRONTPAGE} from '@/modules/finkn/about/frontpage/sanity/constants';
import {DOCUMENT_TYPE_ABOUT_PAGE} from '@/modules/finkn/about/page/sanity/constants';
import {DOCUMENT_TYPE_COMPLAINT_GUIDE_FRONTPAGE} from '@/modules/finkn/complaint-guide/sanity/complaint-guide-frontpage/constants';
import {DOCUMENT_TYPE_FAQ} from '@/modules/finkn/faq/sanity/constants';
import {DOCUMENT_TYPE_FAQ_FRONTPAGE} from '@/modules/finkn/faq/sanity/frontpage/constants';
import {DOCUMENT_TYPE_BANK_AREA} from '@/modules/finkn/field-of-area/bank/area/sanity/constants';
import {DOCUMENT_TYPE_BANK_FRONTPAGE} from '@/modules/finkn/field-of-area/bank/frontpage/sanity/constants';
import {DOCUMENT_TYPE_BANK_GUIDEBOOK} from '@/modules/finkn/field-of-area/bank/guidebook/sanity/constants';
import {DOCUMENT_TYPE_COLLECTION_AREA} from '@/modules/finkn/field-of-area/collection/area/sanity/constants';
import {DOCUMENT_TYPE_COLLECTION_FRONTPAGE} from '@/modules/finkn/field-of-area/collection/frontpage/sanity/constants';
import {DOCUMENT_TYPE_COLLECTION_GUIDEBOOK} from '@/modules/finkn/field-of-area/collection/guidebook/sanity/constants';
import {DOCUMENT_TYPE_INSURANCE_AREA} from '@/modules/finkn/field-of-area/insurance/area/sanity/constants';
import {DOCUMENT_TYPE_INSURANCE_FRONTPAGE} from '@/modules/finkn/field-of-area/insurance/frontpage/sanity/constants';
import {DOCUMENT_TYPE_INSURANCE_GUIDEBOOK} from '@/modules/finkn/field-of-area/insurance/guidebook/sanity/constants';
import {DOCUMENT_TYPE_FINANCE_FRONTPAGE} from '@/modules/finkn/finance/frontpage/sanity/constants';
import {DOCUMENT_TYPE_FINANCE_PAGE} from '@/modules/finkn/finance/page/sanity/constants';
import {DOCUMENT_TYPE_LOGIN_FRONTPAGE} from '@/modules/finkn/login/sanity/constants';
import {DOCUMENT_TYPE_NEMND_FRONTPAGE} from '@/modules/finkn/nemnd/sanity/frontpage/constants';
import {PORTABLE_TEXT_FRAGMENT} from '@/modules/foundation/sanity/portable-text/query';
import {DOCUMENT_TYPE_PAGE} from '@/modules/page/sanity/page/constants';
import {client} from '@/sanity/lib/client';

const PAGES = [
	DOCUMENT_TYPE_PAGE,
	DOCUMENT_TYPE_ARTICLE_FRONTPAGE,
	DOCUMENT_TYPE_ABOUT_FRONTPAGE,
	DOCUMENT_TYPE_FAQ_FRONTPAGE,
	DOCUMENT_TYPE_NEMND_FRONTPAGE,
	DOCUMENT_TYPE_BANK_FRONTPAGE,
	DOCUMENT_TYPE_INSURANCE_FRONTPAGE,
	DOCUMENT_TYPE_COLLECTION_FRONTPAGE,
	DOCUMENT_TYPE_ABOUT_PAGE,
	DOCUMENT_TYPE_INSURANCE_AREA,
	DOCUMENT_TYPE_BANK_AREA,
	DOCUMENT_TYPE_COLLECTION_AREA,
	DOCUMENT_TYPE_INSURANCE_GUIDEBOOK,
	DOCUMENT_TYPE_BANK_GUIDEBOOK,
	DOCUMENT_TYPE_COLLECTION_GUIDEBOOK,
	DOCUMENT_TYPE_FINANCE_FRONTPAGE,
	DOCUMENT_TYPE_FINANCE_PAGE,
	DOCUMENT_TYPE_LOGIN_FRONTPAGE,
	DOCUMENT_TYPE_COMPLAINT_GUIDE_FRONTPAGE,
];

const documentsByIdsQuery = defineQuery(`
		*[_id in $ids]{
			...,
			_type == "${DOCUMENT_TYPE_ARTICLE}" => {
				lead[] {
					${PORTABLE_TEXT_FRAGMENT}
				}
			},
			_type == "${DOCUMENT_TYPE_FAQ}" => {
				answer[] {
					${PORTABLE_TEXT_FRAGMENT}
				}
			}
		}
	`);

export const fetchDocumentsByIds = async (ids: string[]) => {
	if (!ids.length) {
		return [];
	}

	const queryParams = {
		ids: [...ids],
		otherPages: PAGES,
	};

	const documents = await client.fetch(documentsByIdsQuery, queryParams);

	return documents;
};
